<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { Article } from '@/api'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['images']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ForeignKey({
              service: Article,
              label: 'Artykuły',
              modelPath: [this, 'form', 'articles'],
              multiple: true,
              labelField: 'title',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
